export default "__VITE_ASSET__MCecvD1E__"